import React from "react";

const Secondlanding = () => {
  return (
    <div style={styles.responsiveWrapper}>
      <div style={styles.bannerContainer}>
        {/* Top Green Header */}
        <div style={styles.greenHeader}>
          بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ
        </div>

        {/* Central Yellow Body Content */}
        <div style={styles.yellowBody}>
          <p style={styles.textLine}>
            Al QAIM WELFARE FOUNDATION Ka Maqsad - Reza e Ilahi Khushnudi e Imam
            e Zamana (as) aur Muwashere ki bhalai aur madad karna hai
          </p>
          <p style={styles.textLine}>
            AL QAIM WELFARE FOUNDATION IS A SUPPORTING GROUP WHICH HELPS THE
            NEEDY PEOPLE AND TRY TO HELP THEM FINANCIALLY, THIS GROUP IS A
            NON-PROFIT ORGANIZATION IT DOES NOT ASK ANY RETURNS IT'S MOTIVE IS
            TO HELP THE PEOPLE OF SOCIETY AND MAKE A FRIENDLY ENVIRONMENT.
          </p>
        </div>

        {/* Bottom Orange/Gold Footer */}
        <div style={styles.orangeFooter}>
          اَللّٰهُمَّ صَلِّ عَلٰى مُحَمَّدٍ وَّاٰلِ مُحَمَّدٍ
        </div>
      </div>
    </div>
  );
};

// Inline responsive styling rules
const styles = {
  responsiveWrapper: {
    padding: "12px",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
  },
  bannerContainer: {
    width: "100%",
    maxWidth: "800px", // Restricts extreme widening on huge desktop displays
    border: "2px solid #ffffff",
    fontFamily: "Arial, sans-serif",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  },
  greenHeader: {
    backgroundColor: "rgb(170, 130, 28)", // Solid green background
    color: "#ffffff",
    textAlign: "center",
    padding: "8px 4px",
    fontSize: "20px",
    fontWeight: "bold",
    borderBottom: "2px solid #ffffff",
  },
  yellowBody: {
    backgroundColor: "#162f06", // Vibrant yellow background
    color: "#000000",
    padding: "12px 16px",
    fontSize: "15px",
    fontWeight: "bold",
    lineHeight: "1.5",
    textAlign: "left",
    textTransform: "uppercase", // Automatically normalizes text casing matching the image
  },
  textLine: {
    margin: "0 0 12px 0",
    letterSpacing: "0.3px",
    color: "#ffffff",
  },
  orangeFooter: {
    backgroundColor: "rgb(170, 130, 28)", // Deep orange/gold background
    color: "#ffffff",
    textAlign: "center",
    padding: "8px 4px",
    fontSize: "20px",
    fontWeight: "bold",
    borderTop: "2px solid #ffffff",
  },
};

export default Secondlanding;
